import {requestContext} from '../../../../common/requestContext';
import {CommonSectionProps} from '../../type';

export function DisplayAd({children}: CommonSectionProps) {
  if (!requestContext.requestInfo.display.isMobile) {
    return null;
  }

  return <>{children}</>;
}
